export type menu = {
  anchor: string,
  name: string,
  isDisplayMenu: boolean,
  icon: string,
}


export type menusForDisplay = {
  anchor: string,
  name: string,
  isDisplayMenu: boolean,
  icon: JSX.Element,
}


const menus: menu[] = [
  {
    anchor: "MainSection",
    name: "",
    isDisplayMenu: false,
    icon: "",
  },
  {
    anchor: "LanguagesSection",
    name: "Languages",
    isDisplayMenu: true,
    icon: "CheckIcon",
  },
  {
    anchor: "LanguagesDetailSection",
    name: "",
    isDisplayMenu: false,
    icon: "",
  },
  {
    anchor: "WebFrameworksSection",
    name: "WebFrameworks",
    isDisplayMenu: true,
    icon: "CheckIcon",
  },
  {
    anchor: "WebFrameworksDetailSection",
    name: "",
    isDisplayMenu: false,
    icon: "",
  },
  {
    anchor: "AwsSection",
    name: "AWS",
    isDisplayMenu: true,
    icon: "CloudIcon",
  },
  {
    anchor: "AwsSecondSection",
    name: "AWS2",
    isDisplayMenu: false,
    icon: "",
  },
  {
    anchor: "GcpSection",
    name: "GCP",
    isDisplayMenu: true,
    icon: "CloudIcon",
  },
  {
    anchor: "OthersSection",
    name: "Others",
    isDisplayMenu: true,
    icon: "AddIcon",
  },
  {
    anchor: "OthersDetailSection",
    name: "",
    isDisplayMenu: false,
    icon: "",
  },
];

export const anchors = menus.map((menu) => {
  return menu.anchor;
});

export const menusItem = menus.filter((menu) => {
  return menu.isDisplayMenu;
});
